import { Component, Input } from '@angular/core';

@Component({
  selector: 'w-sticky-bar-link',
  templateUrl: './w-sticky-bar-link.component.html',
  host: {
    role: 'listitem',
    class: 'b-sticky-bar__link',
    '[class.b-navigation__shortcut-item--is-type_error]': 'error',
  },
  standalone: false
})
/*
@id w-sticky-bar-link
@name w-sticky-bar-link
@status release
*/
export class WStickyBarLinkComponent {

  @Input() error: boolean = false; // shortcut as error (?)
  @Input() label: string = ''; // link text
  @Input() target?: string; // browser link target (ignored for router links)
  @Input() link?: string; // http link
  @Input() selected: boolean = false; // set true if selected/current link
  @Input() arrowPointer: boolean = false; // set true if drops down drawer
  @Input() routerLink?: string | any[]; // Angular router link (can be array)
  @Input() alternativeRoutes?: string[]; // alternative routes to consider as selected

  @Input() exact: boolean = true; // show link as selected only if precise route match
  @Input() routerState?: { [key: string]: any }; // router data (state)

}
